import { DebugService } from './debug.service.js';

class _PrequalAppService {
  constructor() {
    this.debug = new DebugService('PrequalAppService');
  }

  set application(application) {
    this._application = application;
  }

  get application() {
    return this._application;
  }

  set marketingSource(marketingSource) {
    this._marketingSource = marketingSource;
  }

  get marketingSource() {
    return this._marketingSource;
  }

  get mockApplication() {
    this._application = {
      loanType: 'REFINANCE',
      applicationType: 'INDIVIDUAL',
      profileType: 'financial',
      primaryApplicant: {
        lastName: 'Test',
        firstName: 'Data',
        currentAddress: {},
        dateOfBirth: '1991-01-01',
        employmentInfo: {},
      },
      selectedLoan: {},
      selectedVehicle: {},
    };
    return this._application;
  }

  getPromotion() {
    return this.application.promotion;
  }

  getSelectedVehicle() {
    return this.application.selectedVehicle;
  }

  getSelectedLoan() {
    return this.application.selectedLoan;
  }

  getUsedManualLoan() {
    return this.application.manualEntryFlag;
  }
}

export const PrequalAppService = new _PrequalAppService();
